/**
 * @generated SignedSource<<e81273a37ed80f3e485de30dc1747f9c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EntityTableRow_entity$data = {
  readonly deletable: boolean;
  readonly id: string;
  readonly " $fragmentType": "EntityTableRow_entity";
};
export type EntityTableRow_entity$key = {
  readonly " $data"?: EntityTableRow_entity$data;
  readonly " $fragmentSpreads": FragmentRefs<"EntityTableRow_entity">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EntityTableRow_entity",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deletable",
      "storageKey": null
    }
  ],
  "type": "Entity",
  "abstractKey": "__isEntity"
};

(node as any).hash = "2ce201feb85a6c67ecd9fc503c2b176b";

export default node;
